import React, { useState, useEffect } from "react";
import TimeseriesChart from "../dashboard/timeseriesChart";
import TimeseriesTable from "../dashboard/TimeseriesTable";
import http from "../../services/http";

const Custom = ({ user, data, match }) => {
  const [layout, setLayout] = useState([[]]);

  const getComponent = (component, props) => {
    const Components = {
      1: <TimeseriesChart data={data} {...props} />,
      2: <TimeseriesTable data={data} {...props} />,
    };
    return Components[component.id];
  };

  useEffect(() => {
    async function getLayout() {
      try {
        const { data } = await http.get(`/dashboard-layout/format/${match.params.address}`);
        setLayout(data);
      }
      catch {
        //ignore error
      }
    }
    
    if (match.params.address) {
      getLayout();
    }
  }, [match]);
  return (
    <React.Fragment>
      {layout.map((row, i) => (
        <div key={i} className="row">
          {row.map((col) => (
            <div key={col.COL_NO} className="col">
              {getComponent(col.component, col.config)}
            </div>
          ))}
        </div>
      ))}
    </React.Fragment>
  );
};

export default Custom;

// Row
// --> Col
// ------> Component

// [
//   ["Col1", "Col2", "Col3"],
//   ["Col1", "Col2", "Col3"]
// ];
